"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSwitchToInsurance = exports.useSwitchInsurance = exports.useSwitchFromInsurance = exports.usePatientInsuranceCards = exports.useInsuranceCardUpdate = exports.isMostRecentInsuranceUnderReview = exports.getSoharEligibilityErrorTypes = exports.InsuranceUtil = exports.InsuranceSubmissionFlowTransitionEnum = exports.InsuranceSubmissionFlowStageEnum = void 0;
var _react = require("react");
var _shared = require("../shared");
var _endpoints = require("./endpoints");
var _lodash = require("lodash");
var _ = require("./");
var _useModalState = require("./useModalState");
var _constants = require("./constants");
var _phoneValidator = require("./phoneValidator");
var _usaStates = require("./usaStates.utils");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var InsuranceSubmissionFlowStageEnum = /*#__PURE__*/function (InsuranceSubmissionFlowStageEnum) {
  InsuranceSubmissionFlowStageEnum["DISCOVERY_INFO"] = "discovery-info";
  InsuranceSubmissionFlowStageEnum["SEARCHING_DISCOVERY"] = "searching-discovery";
  InsuranceSubmissionFlowStageEnum["SHORTCUT_INFO"] = "shortcut-info";
  InsuranceSubmissionFlowStageEnum["CHECKING_COVERAGE"] = "checking-coverage";
  InsuranceSubmissionFlowStageEnum["CARD_IMAGES"] = "card-images";
  InsuranceSubmissionFlowStageEnum["SUCCESS"] = "insurance-success";
  InsuranceSubmissionFlowStageEnum["EXITED"] = "exited";
  return InsuranceSubmissionFlowStageEnum;
}({});
exports.InsuranceSubmissionFlowStageEnum = InsuranceSubmissionFlowStageEnum;
var InsuranceSubmissionFlowTransitionEnum = /*#__PURE__*/function (InsuranceSubmissionFlowTransitionEnum) {
  InsuranceSubmissionFlowTransitionEnum["ABORT"] = "abort";
  InsuranceSubmissionFlowTransitionEnum["BACK"] = "back";
  InsuranceSubmissionFlowTransitionEnum["SUBMIT_DISCOVERY_INFO"] = "submitDiscoveryInfo";
  InsuranceSubmissionFlowTransitionEnum["SKIP_DISCOVERY_INFO"] = "skipDiscoveryInfo";
  InsuranceSubmissionFlowTransitionEnum["GET_DISCOVERY_RESPONSE"] = "getDiscoveryResponse";
  InsuranceSubmissionFlowTransitionEnum["SUBMIT_DISCOVERY_RESPONSE"] = "submitDiscoveryResponse";
  InsuranceSubmissionFlowTransitionEnum["SUBMIT_SHORTCUT_INFO"] = "submitShortcutInfo";
  InsuranceSubmissionFlowTransitionEnum["BACK_TO_SHORTCUT_INFO"] = "backToShortcutInfo";
  InsuranceSubmissionFlowTransitionEnum["SUBMIT_CARD_IMAGES"] = "submitCardImages";
  InsuranceSubmissionFlowTransitionEnum["SKIP_CARD_IMAGES"] = "skipCardImages";
  InsuranceSubmissionFlowTransitionEnum["RESTART"] = "restart";
  return InsuranceSubmissionFlowTransitionEnum;
}({});
exports.InsuranceSubmissionFlowTransitionEnum = InsuranceSubmissionFlowTransitionEnum;
var getFullStateName = _usaStates.UsaStatesUtils.getFullStateName;

/**
 * Fetches insurance cards for a patient
 * @param patientId
 * @param config
 * @returns {Result<PatientInsuranceCardDto[], []>} result of the request
 */
var usePatientInsuranceCards = function usePatientInsuranceCards() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var config = arguments.length > 1 ? arguments[1] : undefined;
  var _useAuth = (0, _shared.useAuth)(),
    isAuthenticated = _useAuth.isAuthenticated;
  var defaultConfig = {
    ready: isAuthenticated
  };
  return (0, _.useRequest)((0, _endpoints.getPatientInsuranceCards)(patientId), config || defaultConfig);
};
exports.usePatientInsuranceCards = usePatientInsuranceCards;
var useSwitchToInsurance = function useSwitchToInsurance() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return (0, _.useRequest)({
    method: 'post',
    url: (0, _endpoints.getPatientSwitchToInsurance)(patientId)
  }, {
    manual: true
  });
};
exports.useSwitchToInsurance = useSwitchToInsurance;
var useSwitchFromInsurance = function useSwitchFromInsurance() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return (0, _.useRequest)({
    method: 'post',
    url: (0, _endpoints.getPatientSwitchFromInsurance)(patientId)
  }, {
    manual: true
  });
};
exports.useSwitchFromInsurance = useSwitchFromInsurance;
var useSwitchInsurance = function useSwitchInsurance() {
  var patientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  var cardId = arguments.length > 1 ? arguments[1] : undefined;
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess;
  return (0, _.useRequest)({
    method: 'post',
    url: (0, _endpoints.getPatientSwitchInsurance)(patientId, cardId)
  }, {
    manual: true,
    onSuccess: onSuccess
  });
};
exports.useSwitchInsurance = useSwitchInsurance;
var dollarsStringToCentsOrNull = function dollarsStringToCentsOrNull(value) {
  // Catches null and empty string
  if (!value) {
    return null;
  }
  var num = parseFloat(value);
  return !Number.isNaN(num) ? Math.round(num * 100) : null;
};
var percentStringToNumber = function percentStringToNumber(value) {
  // Catches null and empty string
  if (!value) {
    return null;
  }
  var num = parseFloat(value);
  return !Number.isNaN(num) ? num : null;
};
var useInsuranceCardUpdate = function useInsuranceCardUpdate(card, form, patientId, onSubmit, activeCardId, refetchCards) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    uploading = _useState2[0],
    setUploading = _useState2[1];
  var underReviewToActiveStatusConfirmationModal = (0, _useModalState.useModalState)();
  var activeToNotOptedOutStatusConfirmationModal = (0, _useModalState.useModalState)();
  var underReviewStatusChangeSuggestionModal = (0, _useModalState.useModalState)();
  var optedOutStatusChangeConfirmationModal = (0, _useModalState.useModalState)();
  var anotherActiveCardConfirmationModal = (0, _useModalState.useModalState)();
  var changeAffectingEligibilityModal = (0, _useModalState.useModalState)();
  var _useRequest = (0, _.useRequest)(function (data) {
      return {
        url: (0, _.getPatientInsuranceCardAndBenefitData)(patientId, card.id),
        method: 'patch',
        data: data
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _.toast.success({
          title: 'Insurance card data successfully updated'
        });
      }
    }),
    loading = _useRequest.loading,
    saveCard = _useRequest.runAsync;
  var _useRequest2 = (0, _.useRequest)(function () {
      return {
        url: (0, _endpoints.getPatientInsuranceSoharEligibilityUrl)(patientId, card.id),
        method: 'patch'
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _.toast.success({
          title: 'Insurance card eligibility successfully updated'
        });
      }
    }),
    loadingRefreshEligibility = _useRequest2.loading,
    refreshEligibility = _useRequest2.runAsync;
  var handleUpdate = function handleUpdate(recheckEligibility) {
    form.validateFieldsAndScroll( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err, values) {
        var payload, eligiblePhysicianAppointments, eligibleTherapistAppointments, copayPhysicianAppointments, copayTherapistAppointments, deductibleAnnualPhysicianAppointments, deductibleAnnualTherapistAppointments, deductibleRemainingPhysicianAppointments, deductibleRemainingTherapistAppointments, coInsurancePhysicianAppointments, coInsuranceTherapistAppointments, _values$insuranceCard, insuranceCardFrontImage, _values$insuranceCard2, insuranceCardBackImage, status, isCurrentCardActivation, isAnotherCardActive, fieldsToCompare, hasChangeAffectingEligibility, draftBenefit, oldBenefit, benefit, _insuranceCardFrontIm, imageFileFront, _insuranceCardBackIma, imageFileBack, frontImageNotPreloaded, backImageNotPreloaded, _yield$Promise$all, _yield$Promise$all2, frontImageId, backImageId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = _objectSpread({}, values);
                eligiblePhysicianAppointments = values.eligiblePhysicianAppointments, eligibleTherapistAppointments = values.eligibleTherapistAppointments, copayPhysicianAppointments = values.copayPhysicianAppointments, copayTherapistAppointments = values.copayTherapistAppointments, deductibleAnnualPhysicianAppointments = values.deductibleAnnualPhysicianAppointments, deductibleAnnualTherapistAppointments = values.deductibleAnnualTherapistAppointments, deductibleRemainingPhysicianAppointments = values.deductibleRemainingPhysicianAppointments, deductibleRemainingTherapistAppointments = values.deductibleRemainingTherapistAppointments, coInsurancePhysicianAppointments = values.coInsurancePhysicianAppointments, coInsuranceTherapistAppointments = values.coInsuranceTherapistAppointments, _values$insuranceCard = values.insuranceCardFrontImage, insuranceCardFrontImage = _values$insuranceCard === void 0 ? [] : _values$insuranceCard, _values$insuranceCard2 = values.insuranceCardBackImage, insuranceCardBackImage = _values$insuranceCard2 === void 0 ? [] : _values$insuranceCard2, status = values.status;
                if (!(status === _constants.INSURANCE_CARD_STATUSES.OPTED_OUT && card.status === _constants.INSURANCE_CARD_STATUSES.ACTIVE)) {
                  _context.next = 5;
                  break;
                }
                optedOutStatusChangeConfirmationModal.show();
                return _context.abrupt("return");
              case 5:
                if (!(!activeToNotOptedOutStatusConfirmationModal.visible && card.status !== status && status !== _constants.INSURANCE_CARD_STATUSES.OPTED_OUT && card.status === _constants.INSURANCE_CARD_STATUSES.ACTIVE)) {
                  _context.next = 8;
                  break;
                }
                activeToNotOptedOutStatusConfirmationModal.show();
                return _context.abrupt("return");
              case 8:
                isCurrentCardActivation = status === _constants.INSURANCE_CARD_STATUSES.ACTIVE && card.status !== _constants.INSURANCE_CARD_STATUSES.ACTIVE;
                isAnotherCardActive = !!activeCardId && activeCardId !== card.id;
                if (!(isCurrentCardActivation && isAnotherCardActive && !anotherActiveCardConfirmationModal.visible)) {
                  _context.next = 13;
                  break;
                }
                anotherActiveCardConfirmationModal.show();
                return _context.abrupt("return");
              case 13:
                fieldsToCompare = ['firstName', 'lastName', 'birthDate', 'memberId', 'payerId'];
                hasChangeAffectingEligibility = !(0, _lodash.isEqual)((0, _lodash.pick)(values, fieldsToCompare), _objectSpread(_objectSpread({}, (0, _lodash.pick)(card, fieldsToCompare)), {}, {
                  birthDate: (0, _.formatDateField)(card.birthDate)
                }));
                if (!(changeAffectingEligibilityModal.numShows === 0 && hasChangeAffectingEligibility)) {
                  _context.next = 18;
                  break;
                }
                changeAffectingEligibilityModal.show();
                return _context.abrupt("return");
              case 18:
                draftBenefit = {
                  eligiblePhysicianAppointments: eligiblePhysicianAppointments,
                  eligibleTherapistAppointments: eligibleTherapistAppointments,
                  copayPhysicianAppointments: dollarsStringToCentsOrNull(copayPhysicianAppointments),
                  copayTherapistAppointments: dollarsStringToCentsOrNull(copayTherapistAppointments),
                  deductibleAnnualPhysicianAppointments: dollarsStringToCentsOrNull(deductibleAnnualPhysicianAppointments),
                  deductibleAnnualTherapistAppointments: dollarsStringToCentsOrNull(deductibleAnnualTherapistAppointments),
                  deductibleRemainingPhysicianAppointments: dollarsStringToCentsOrNull(deductibleRemainingPhysicianAppointments),
                  deductibleRemainingTherapistAppointments: dollarsStringToCentsOrNull(deductibleRemainingTherapistAppointments),
                  coInsurancePhysicianAppointments: percentStringToNumber(coInsurancePhysicianAppointments),
                  coInsuranceTherapistAppointments: percentStringToNumber(coInsuranceTherapistAppointments)
                };
                oldBenefit = (0, _lodash.pick)(card.benefit, ['eligiblePhysicianAppointments', 'eligibleTherapistAppointments', 'copayPhysicianAppointments', 'copayTherapistAppointments', 'deductibleAnnualPhysicianAppointments', 'deductibleAnnualTherapistAppointments', 'deductibleRemainingPhysicianAppointments', 'deductibleRemainingTherapistAppointments', 'coInsurancePhysicianAppointments', 'coInsuranceTherapistAppointments']);
                if (!(underReviewStatusChangeSuggestionModal.numShows === 0 && status === card.status && (0, _.isCardUnderReview)(status) && !(0, _lodash.isEmpty)(draftBenefit) && !(0, _lodash.isEqual)(draftBenefit, oldBenefit))) {
                  _context.next = 23;
                  break;
                }
                underReviewStatusChangeSuggestionModal.show();
                return _context.abrupt("return");
              case 23:
                benefit = oldBenefit ? (0, _lodash.omitBy)(draftBenefit, function (value, name) {
                  return oldBenefit[name] === value;
                }) : (0, _lodash.omitBy)(draftBenefit, _lodash.isEmpty);
                if (!(0, _lodash.isEmpty)(benefit)) {
                  if (card.benefit) {
                    benefit.id = card.benefit.id;
                  }
                  benefit.patientId = patientId;
                  payload.benefit = benefit;
                }
                setUploading(true);
                _insuranceCardFrontIm = _slicedToArray(insuranceCardFrontImage, 1), imageFileFront = _insuranceCardFrontIm[0];
                _insuranceCardBackIma = _slicedToArray(insuranceCardBackImage, 1), imageFileBack = _insuranceCardBackIma[0]; // Since we're loading previous item into new cycle of insurance flow,
                // we only re-upload images if there's a change in corresponding uploads
                frontImageNotPreloaded = imageFileFront === null || imageFileFront === void 0 ? void 0 : imageFileFront.originFileObj;
                backImageNotPreloaded = imageFileBack === null || imageFileBack === void 0 ? void 0 : imageFileBack.originFileObj;
                _context.prev = 30;
                _context.next = 33;
                return Promise.all([frontImageNotPreloaded && (0, _.uploadImage)({
                  file: imageFileFront,
                  url: (0, _.getPatientImageUploadUrl)()
                }), backImageNotPreloaded && (0, _.uploadImage)({
                  file: imageFileBack,
                  url: (0, _.getPatientImageUploadUrl)()
                })]);
              case 33:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                frontImageId = _yield$Promise$all2[0];
                backImageId = _yield$Promise$all2[1];
                payload.insuranceCardFrontImage = frontImageNotPreloaded ? frontImageId : card.insuranceCardFrontImage;
                payload.insuranceCardBackImage = backImageNotPreloaded ? backImageId : card.insuranceCardBackImage;
                payload.enrollmentDate = payload.enrollmentDate ? (0, _.formatDateInputString)(payload.enrollmentDate) : null;
                payload.unenrolledDatePhysician = payload.unenrolledDatePhysician ? (0, _.formatDateInputString)(payload.unenrolledDatePhysician) : null;
                payload.unenrolledDateTherapy = payload.unenrolledDateTherapy ? (0, _.formatDateInputString)(payload.unenrolledDateTherapy) : null;
                payload.birthDate = payload.birthDate ? (0, _.formatDateInputString)(payload.birthDate) : null;
                payload.isMedicare = payload.isMedicare || null;
                payload.isMedicaid = payload.isMedicaid || null;
                if (payload.phoneNumber) {
                  payload.phoneNumber = (0, _phoneValidator.trimPhoneNumber)(payload.phoneNumber);
                } else {
                  payload.phoneNumber = null;
                }
                _context.next = 48;
                return saveCard(payload);
              case 48:
                if (!recheckEligibility) {
                  _context.next = 51;
                  break;
                }
                _context.next = 51;
                return refreshEligibility();
              case 51:
                onSubmit(card.id);
                _context.next = 57;
                break;
              case 54:
                _context.prev = 54;
                _context.t0 = _context["catch"](30);
                _.toast.error({
                  title: 'An error has occured',
                  description: 'There was a problem with saving insurance card changes, please try again'
                });
              case 57:
                _context.prev = 57;
                setUploading(false);
                refetchCards();
                return _context.finish(57);
              case 61:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[30, 54, 57, 61]]);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  };
  return {
    loading: loading || loadingRefreshEligibility,
    uploading: uploading,
    handleUpdate: handleUpdate,
    underReviewStatusChangeSuggestionModal: underReviewStatusChangeSuggestionModal,
    optedOutStatusChangeConfirmationModal: optedOutStatusChangeConfirmationModal,
    underReviewToActiveStatusConfirmationModal: underReviewToActiveStatusConfirmationModal,
    activeToNotOptedOutStatusConfirmationModal: activeToNotOptedOutStatusConfirmationModal,
    anotherActiveCardConfirmationModal: anotherActiveCardConfirmationModal,
    changeAffectingEligibilityModal: changeAffectingEligibilityModal
  };
};
exports.useInsuranceCardUpdate = useInsuranceCardUpdate;
var benefitHasEligibilityData = function benefitHasEligibilityData(benefit) {
  if (!benefit) {
    return false;
  }
  var eligiblePhysicianAppointments = benefit.eligiblePhysicianAppointments,
    eligibleTherapistAppointments = benefit.eligibleTherapistAppointments,
    coInsurancePhysicianAppointments = benefit.coInsurancePhysicianAppointments,
    coInsuranceTherapistAppointments = benefit.coInsuranceTherapistAppointments,
    copayPhysicianAppointments = benefit.copayPhysicianAppointments,
    copayTherapistAppointments = benefit.copayTherapistAppointments,
    deductibleAnnualPhysicianAppointments = benefit.deductibleAnnualPhysicianAppointments,
    deductibleAnnualTherapistAppointments = benefit.deductibleAnnualTherapistAppointments,
    isFreeCoreMembershipDiscount = benefit.isFreeCoreMembershipDiscount;
  if (!eligiblePhysicianAppointments && !eligibleTherapistAppointments && !isFreeCoreMembershipDiscount) {
    return false;
  }
  var copayValue = (0, _lodash.isNumber)(copayPhysicianAppointments) || (0, _lodash.isNumber)(copayTherapistAppointments);
  var coinsuranceValue = (0, _lodash.isNumber)(coInsurancePhysicianAppointments) || (0, _lodash.isNumber)(coInsuranceTherapistAppointments);
  var deductibleValue = (0, _lodash.isNumber)(deductibleAnnualPhysicianAppointments) || (0, _lodash.isNumber)(deductibleAnnualTherapistAppointments);
  if (copayValue || coinsuranceValue || deductibleValue || isFreeCoreMembershipDiscount) {
    return true;
  }
  return false;
};
var getPayerNameFromCard = function getPayerNameFromCard() {
  var card = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var payerId = card.payerId,
    payer = card.payer,
    insurer = card.insurer;
  if (payerId && !payer) {
    return '';
  }
  return (payer === null || payer === void 0 ? void 0 : payer.payerName) || insurer;
};
var getInsuranceComparisonFullData = function getInsuranceComparisonFullData(subscriptions, _ref3, payerNames) {
  var activeCardComparisonData = _ref3.activeCardComparisonData,
    eligibleCardComparisonData = _ref3.eligibleCardComparisonData;
  return {
    plans: (0, _lodash.compact)(subscriptions.map(function (plan) {
      if ((0, _.isFreemium)(plan.planId)) {
        return null;
      }
      var activePlanData = (0, _lodash.find)(activeCardComparisonData, function (row) {
        return row.priceId === plan.planId;
      });
      var eligiblePlanData = (0, _lodash.find)(eligibleCardComparisonData, function (row) {
        return row.priceId === plan.planId;
      });
      var comparisonData = {
        title: plan.title
      };
      if (activePlanData) {
        comparisonData.active = activePlanData;
      }
      if (eligiblePlanData) {
        comparisonData.eligible = eligiblePlanData;
      }
      return comparisonData;
    })),
    providers: (0, _lodash.compact)(payerNames)
  };
};

/**
 * Finds the first active insurance card in the list
 * @param {PatientInsuranceCardDto[]} cards
 * @returns {PatientInsuranceCardDto | undefined} active insurance card or undefined
 */
var findActiveInsurance = function findActiveInsurance(cards) {
  return (0, _lodash.find)(cards, function (card) {
    return card.status === _constants.INSURANCE_CARD_STATUSES.ACTIVE;
  });
};

/**
 * Finds the first pending eligible insurance card in the list
 * @param {PatientInsuranceCardDto[]} cards
 * @returns {PatientInsuranceCardDto | undefined} pending eligible insurance card or undefined
 * */
var findPendingEligibleInsurance = function findPendingEligibleInsurance(cards) {
  return isActiveInsurance(cards) ? undefined : (0, _lodash.find)(cards, function (card) {
    return card.status === _constants.INSURANCE_CARD_STATUSES.ELIGIBLE;
  });
};
var isEligibleInsurance = function isEligibleInsurance(cards) {
  return (0, _lodash.some)(cards, function (card) {
    return card.status === _constants.INSURANCE_CARD_STATUSES.ELIGIBLE;
  });
};
var isActiveInsurance = function isActiveInsurance(cards) {
  return (0, _lodash.some)(cards, function (card) {
    return card.status === _constants.INSURANCE_CARD_STATUSES.ACTIVE;
  });
};
var isPendingEligibleInsurance = function isPendingEligibleInsurance(cards) {
  return isEligibleInsurance(cards) && !isActiveInsurance(cards);
};
var isCardStatusAllowsInsuranceSubmit = function isCardStatusAllowsInsuranceSubmit(status) {
  return [_constants.INSURANCE_CARD_STATUSES.OPTED_OUT, _constants.INSURANCE_CARD_STATUSES.ACTIVE].includes(status);
};
var isCardStatusRequiresInsuranceSubmit = function isCardStatusRequiresInsuranceSubmit(status) {
  return [_constants.INSURANCE_CARD_STATUSES.OPTED_OUT].includes(status);
};
var getMostRecentInsurance = function getMostRecentInsurance(cards) {
  return (0, _lodash.orderBy)(cards, ['createdAt'], ['desc'])[0];
};
var isMostRecentInsuranceUnderReview = function isMostRecentInsuranceUnderReview(cards) {
  var recentInsurance = getMostRecentInsurance(cards);
  return (0, _.isCardUnderReview)(recentInsurance === null || recentInsurance === void 0 ? void 0 : recentInsurance.status);
};

// most valid is the which is more closer to 'active', or the newest one
exports.isMostRecentInsuranceUnderReview = isMostRecentInsuranceUnderReview;
var getMostValidInsurance = function getMostValidInsurance(cards) {
  return (0, _lodash.orderBy)(cards, [function (_ref4) {
    var status = _ref4.status;
    return (0, _lodash.indexOf)([_constants.INSURANCE_CARD_STATUSES.ACTIVE, _constants.INSURANCE_CARD_STATUSES.ELIGIBLE, _constants.INSURANCE_CARD_STATUSES.INELIGIBLE, _constants.INSURANCE_CARD_STATUSES.PENDING, _constants.INSURANCE_CARD_STATUSES.OPTED_OUT], status);
  }, 'createdAt'], ['asc', 'desc'])[0];
};

// show banner only 14 days
var isIneligibleBannerVisible = function isIneligibleBannerVisible(card) {
  return (card === null || card === void 0 ? void 0 : card.status) === _constants.INSURANCE_CARD_STATUSES.INELIGIBLE && (0, _momentTimezone.default)(new Date()).diff((0, _momentTimezone.default)(card === null || card === void 0 ? void 0 : card.createdAt), 'd') < 14;
};
var isInsuranceSubmissionInProgress = function isInsuranceSubmissionInProgress(submission) {
  return submission.flow.data && submission.flow.data.stage !== InsuranceSubmissionFlowStageEnum.EXITED;
};
var getSoharEligibilityErrorTypes = function getSoharEligibilityErrorTypes(errMessage) {
  var types = [];
  if (!errMessage || !(0, _lodash.isString)(errMessage)) {
    return types;
  }
  if (errMessage.includes('error.member.id')) {
    types.push('memberId');
  }
  if (errMessage.includes('error.member.dob')) {
    types.push('dob');
  }
  if (errMessage.includes('error.member.name')) {
    types.push('name');
  }
  return types;
};
exports.getSoharEligibilityErrorTypes = getSoharEligibilityErrorTypes;
var InsuranceUtil = {
  useSwitchToInsurance: useSwitchToInsurance,
  useSwitchFromInsurance: useSwitchFromInsurance,
  useSwitchInsurance: useSwitchInsurance,
  benefitHasEligibilityData: benefitHasEligibilityData,
  getPayerNameFromCard: getPayerNameFromCard,
  getInsuranceComparisonFullData: getInsuranceComparisonFullData,
  getMostValidInsurance: getMostValidInsurance,
  getMostRecentInsurance: getMostRecentInsurance,
  isActiveInsurance: isActiveInsurance,
  isEligibleInsurance: isEligibleInsurance,
  isPendingEligibleInsurance: isPendingEligibleInsurance,
  isCardStatusAllowsInsuranceSubmit: isCardStatusAllowsInsuranceSubmit,
  isCardStatusRequiresInsuranceSubmit: isCardStatusRequiresInsuranceSubmit,
  isIneligibleBannerVisible: isIneligibleBannerVisible,
  isInsuranceSubmissionInProgress: isInsuranceSubmissionInProgress,
  findPendingEligibleInsurance: findPendingEligibleInsurance,
  findActiveInsurance: findActiveInsurance
};
exports.InsuranceUtil = InsuranceUtil;